import React from 'react';
import { motion } from 'framer-motion';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

const DesignOffice = () => {
  const carouselItems = [
    {
      image: "/assets/images/design-office/SOUS CATEGORIE - BUREAU D'ETUDE (bandeau).jpg",
      title: "Bureau d'étude",
      description: "Bureau d'étude spécialisé en design et aménagement"
    },
    {
      image: "/assets/images/design-office/SOUS CATEGORIE - BUREAU D'ETUDE - DESIGN INTERIEUR.jpg",
      title: "Design intérieur",
      description: "Créations uniques et personnalisées"
    },
    {
      image: "/assets/images/design-office/SOUS CATEGORIE - BUREAU D'ETUDE - AMENAGEMENT.jpg",
      title: "Aménagement",
      description: "Solutions sur mesure"
    }
  ];

  return (
    <div className="min-h-screen bg-[#303030]">
      {/* Carousel Landing Section */}
      <section className="relative h-screen">
        <Carousel
          autoPlay
          infiniteLoop
          showStatus={false}
          showThumbs={false}
          interval={5000}
          className="h-full"
        >
          {carouselItems.map((item, index) => (
            <div key={index} className="h-screen relative">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                <div className="text-center text-cream">
                  <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-4xl md:text-6xl lg:text-8xl font-cormorant font-light mb-6"
                  >
                    {item.title}
                  </motion.h1>
                  <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-lg md:text-xl"
                  >
                    {item.description}
                  </motion.p>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </section>

      {/* Text Section */}
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-xl text-center text-cream mb-16"
          >
            Notre bureau d'étude s'engage à créer des espaces qui reflètent votre vision et répondent à vos besoins.
            Nous combinons expertise technique et créativité pour donner vie à vos projets.
          </motion.p>
        </div>
      </section>

      {/* Image and Text Section */}
      <section className="py-20 px-4 bg-[#303030]">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="w-full md:w-1/2"
          >
            <img
              src="/assets/images/design-office/SOUS CATEGORIE - BUREAU D'ETUDE - NOTRE APPROCHE.jpg"
              alt="Design Process"
              className="w-full h-[600px] object-cover rounded-lg"
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="w-full md:w-1/2 text-cream"
          >
            <h2 className="text-3xl md:text-4xl font-cormorant mb-6">Notre approche</h2>
            <p className="text-lg mb-6">
              Showroom mobilier contemporain, luminaires et cuisine, aménagement pour particuliers et professionnels à Aix-en-Provence.
              Isiliving crée en 2016 à Aix en Provence est devenu un acteur incontournable du secteur du mobilier design et de l'aménagement intérieur.
              Forte de 20 ans d'expérience dans ce domaine, sa fondatrice Jacquie Taioglou s'est entourée d'une équipe professionnelle.

              Passionnée de décoration et de mobilier, elle s’est orientée il y a quelques années dans l’aménagement d'intérieur.

              Notre bureau d'étude réalise tous vos projets d'aménagements pour particuliers et professionnels, pour votre habitat ou pour l'agencement de vos bureaux, restaurants et professions libérales.
            </p>
            <ul className="space-y-4">
              <li className="flex items-center gap-4">
                <span className="text-2xl">→</span>
                <span>Analyse approfondie de vos besoins</span>
              </li>
              <li className="flex items-center gap-4">
                <span className="text-2xl">→</span>
                <span>Conception créative et technique</span>
              </li>
              <li className="flex items-center gap-4">
                <span className="text-2xl">→</span>
                <span>Réalisation détaillée</span>
              </li>
            </ul>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default DesignOffice;